import React, { useState, useEffect } from "react";
import DeleteModal from "../Assets/DeleteModal"; 
import { TbEdit } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";
import { db } from "../Config/Firebase"; 
import {
  collection,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  setDoc,
} from "firebase/firestore";

const Settings = ({ isSidebarCollapsed }) => {
  const [Purposes, setPurposes] = useState([]);
const [formData, setFormData] = useState({
  amountInINR: "",
  coins: "",
  offerType: "Normal",
  imgUrl: "",
  diamond: "",
  diamondImgUrl: "",
  visibleTo: [],  
});
  const [editId, setEditId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "rechargePlans"));
        const plans = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPurposes(plans);
      } catch (error) {
        console.error("Error fetching rechargePlans:", error);
      }
    };

    fetchData();
  }, []);

const handleInputChange = (e) => {
  const { name, value, checked } = e.target;

  if (name === "amountInINR" || name === "coins") {
    if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  } else if (name === "visibleTo") {
    setFormData((prev) => {
      let updated = [...prev.visibleTo];
      if (checked) {
        if (!updated.includes(value)) updated.push(value);
      } else {
        updated = updated.filter((item) => item !== value);
      }
      return { ...prev, visibleTo: updated };
    });
  } else {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
};



  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    if (editId) {
      
      const docRef = doc(db, "rechargePlans", editId);
      await updateDoc(docRef, formData);

      setPurposes((prev) =>
        prev.map((item) =>
          item.id === editId ? { ...item, ...formData } : item
        )
      );
    } else {
      
      const ids = Purposes.map((p) => Number(p.id)).filter((n) => !isNaN(n));
      const maxId = ids.length ? Math.max(...ids) : 0;
      const newId = (maxId + 1).toString();
      const label = `Plan ${newId}`;
      
      await setDoc(doc(db, "rechargePlans", newId), { ...formData, label });

      setPurposes((prev) => [...prev, { id: newId, ...formData, label }]);
    }

    setFormData({ amountInINR: "", coins: "", offerType: "Normal" ,imgUrl:"", diamond: "", diamondImgUrl: "", visibleTo: [] });
    setEditId(null);
  } catch (error) {
    console.error("Error saving rechargePlan:", error);
  }
};
  const handleEdit = (id) => {
    const purposeToEdit = Purposes.find((p) => p.id === id);
    if (purposeToEdit) {
      setFormData({
        amountInINR: purposeToEdit.amountInINR,
        coins: purposeToEdit.coins,
        offerType: purposeToEdit.offerType || "Normal",
        imgUrl: purposeToEdit.imgUrl || "",
        diamondImgUrl: purposeToEdit.diamondImgUrl || "",
        diamond: purposeToEdit.diamond || "",
        visibleTo: purposeToEdit.visibleTo || [],
      });
      setEditId(id);
    }
  };

  const cancelEdit = () => {
    setFormData({ amountInINR: "", coins: "", offerType: "Normal", imgUrl: "", diamond: "", diamondImgUrl: "", visibleTo: [] });
    setEditId(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await deleteDoc(doc(db, "rechargePlans", itemToDelete));
        setPurposes((prev) => prev.filter((item) => item.id !== itemToDelete));
      } catch (error) {
        console.error("Error deleting rechargePlan:", error);
      }
    }
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  return (
    <div className=" coin-settings-container">
      
      <div className="bg-white p-[1vw]  coin-settings-form-container">
        <div className="text-[20px] font-bold border-b-1 text-gray-600 border-gray-300 pb-[2px]">
          <h1 className="text-gray-600">
            {editId ? "Update Coin Settings" : "Add Coin Settings"}
          </h1>
        </div>
        <form className="bg-white pt-1 rounded-lg" onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Select Offer Type *
            </label>
            <select
              name="offerType"
              value={formData.offerType || "normal"}
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            >
              <option value="Normal">Normal Offer</option>
              <option value="Special">Special Offer</option>
            </select>
          </div>

          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Coin Price (Rupees) *
            </label>
            <input
              name="amountInINR"
              value={formData.amountInINR}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter Coin Price"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
              min="0"
              step="any"
            />
          </div>
          

          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Coin Amount *
            </label>
            <input
              name="coins"
              value={formData.coins}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter Coin Amount"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
              min="0"
              step="any"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Diamond Amount *
            </label>
            <input
              name="diamond"
              value={formData.diamond}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter Diamond Amount"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
              min="0"
              step="any"
            />
          </div>
          <div className="mb-4 flex items-center gap-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Visible To *
            </label>

            <div className="flex items-center gap-4">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  name="visibleTo"
                  value="Male"
                  checked={formData.visibleTo.includes("Male")}
                  onChange={handleInputChange}
                  className="mr-2 leading-tight"
                />
                <span className="text-gray-700">Male</span>
              </label>

              <label className="flex items-center">
                <input
                  type="checkbox"
                  name="visibleTo"
                  value="Female"
                  checked={formData.visibleTo.includes("Female")}
                  onChange={handleInputChange}
                  className="mr-2 leading-tight"
                />
                <span className="text-gray-700">Female</span>
              </label>
            </div>
          </div>


          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Upload Coin Image (URL)
            </label>
            <input
              type="text"
              name="imgUrl"
              onChange={handleInputChange}
              value={formData.imgUrl}
              placeholder="Enter Coin Image URL"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Upload Diamond Image (URL)
            </label>
            <input
              type="text"
              name="diamondImgUrl"
              onChange={handleInputChange}
              value={formData.diamondImgUrl}
              placeholder="Enter Diamond Image URL"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>


          <div className="flex items-center gap-2">
            <button
              type="submit"
              className="bg-blue-500 text-sm hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              {editId ? "Update" : "Save"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={cancelEdit}
                className="bg-gray-500 text-sm hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Table */}
      <ul className="w-full coin-settings-display-container">
        <li className="bg-white p-[1vw]">
          <div className="text-[20px] font-bold pb-[10px]">
            <h1>Coin Settings </h1>
          </div>
          <section className="flex flex-col justify-center">
            <div className="h-full">
              <div className="w-full bg-white">
                <div className="overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead className="font-semibold uppercase text-white bg-blue-500">
                      <tr className="grid text-xs grid-cols-5">
                        
                        <th className="p-2 whitespace-nowrap">
                          <div className="font-semibold text-left">Type <br /> (Offer)</div>
                        </th>
                        <th className="p-2 whitespace-nowrap">
                          <div className="font-semibold text-left">Plans</div>
                        </th>
                        <th className="p-2 whitespace-nowrap">
                          <div className="font-semibold text-right">Amount <br />(INR)</div>
                        </th>
                        <th className="p-2 whitespace-nowrap">
                          <div className="font-semibold text-right">Coins</div>
                        </th>
                        <th className="p-2 whitespace-nowrap">
                          <div className="font-semibold text-center">Action</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {Purposes.length > 0 ? (
                        Purposes.map((log) => (
                          <tr className="grid grid-cols-5" key={log.id}>
                            <td className="p-2 whitespace-nowrap">
                              <div
                                className={`text-left font-medium text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {log.offerType || "N/A"}
                              </div>
                            </td>

                            <td className="p-2 whitespace-nowrap">
                              <div
                                className={`text-right  text-gray-800 flex items-center gap-1 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                <img
                                  src={log.imgUrl}
                                  alt={log.label || "N/A"}
                                  className={`rounded-full ${
                                    isSidebarCollapsed ? "w-10 h-10" : "w-4 h-4"
                                  }`}
                                />
                                <span className={`text-right  text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}>{log.label || "N/A"}</span>
                              </div>
                            </td>

                            <td className="p-2 whitespace-nowrap">
                              <div
                                className={`text-right  text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {log.amountInINR}
                              </div>
                            </td>

                            <td className="p-2 whitespace-nowrap">
                              <div
                                className={`text-right text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {log.coins}
                              </div>
                            </td>

                            <td className="p-2 whitespace-nowrap">
                              <div className="flex gap-2 justify-center items-center">
                                <button
                                  onClick={() => handleEdit(log.id)}
                                  className={`text-blue-500 hover:text-blue-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Edit"
                                >
                                  <TbEdit />
                                </button>
                                <button
                                  onClick={() => handleDeleteClick(log.id)}
                                  className={`text-red-500 hover:text-red-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Delete"
                                >
                                  <MdDeleteOutline />
                                </button>
                              </div>
                            </td>
                          </tr>

                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="p-2 text-center">
                            No Coin Details added yet
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </li>
        {/*<li className="bg-white p-[1vw]">
          <div className="text-[20px] font-bold pb-[10px]">
            <h1>Diamond Settings </h1>
          </div>
          <section className="flex flex-col justify-center">
            <div className="h-full">
              <div className="w-full bg-white">
                <div className="overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead className="font-semibold uppercase text-white bg-blue-500">
                      <tr className="grid text-xs grid-cols-5">
                        <th className="p-2 whitespace-nowrap">
                          <div className="font-semibold text-left">Plans</div>
                        </th>
                        <th className="p-2 whitespace-nowrap">
                          <div className="font-semibold text-right">Amount <br /> (INR)</div>
                        </th>
                        <th className="p-2 whitespace-nowrap">
                          <div className="font-semibold text-right">Diamonds</div>
                        </th>
                        <th className="p-2 whitespace-nowrap">
                          <div className="font-semibold text-right">Visible To <br /> (Gender)</div>
                        </th>
                        <th className="p-2 whitespace-nowrap">
                          <div className="font-semibold text-center">Action</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {Purposes.length > 0 ? (
                        Purposes.map((log) => (
                          <tr className="grid grid-cols-5" key={log.id}>
                            <td className="p-2 whitespace-nowrap">
                              <div
                                className={`text-right  text-gray-800 flex items-center gap-1 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                <img
                                  src={log.diamondImgUrl}
                                  alt={log.label || "N/A"}
                                  className={`rounded-full ${
                                    isSidebarCollapsed ? "w-10 h-10" : "w-4 h-4"
                                  }`}
                                />
                                <span className={`text-right  text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}>{log.label || "N/A"}</span>
                              </div>
                            </td>

                            <td className="p-2 whitespace-nowrap">
                              <div
                                className={`text-right  text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {log.amountInINR}
                              </div>
                            </td>
                            <td className="p-2 whitespace-nowrap">
                              <div
                                className={`text-right text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {log.diamond}
                              </div>
                            </td>
                            <td className="p-2 whitespace-nowrap">
                              <div
                                className={`text-right text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {log.visibleTo && log.visibleTo.length > 0
                                  ? log.visibleTo.join(", ")
                                  : "N/A"}
                              </div>
                            </td>

                            <td className="p-2 whitespace-nowrap">
                              <div className="flex gap-2 justify-center items-center">
                                <button
                                  onClick={() => handleEdit(log.id)}
                                  className={`text-blue-500 hover:text-blue-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Edit"
                                >
                                  <TbEdit />
                                </button>
                                <button
                                  onClick={() => handleDeleteClick(log.id)}
                                  className={`text-red-500 hover:text-red-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Delete"
                                >
                                  <MdDeleteOutline />
                                </button>
                              </div>
                            </td>
                          </tr>

                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="p-2 text-center">
                            No Diamond Details added yet
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </li>*/}
      </ul>

      {/* Delete Modal */}
      {deleteModalShow && (
        <DeleteModal
          itemName={Purposes.find((p) => p.id === itemToDelete)?.label || "Purpose"}
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
    </div>
  );
};

export default Settings; 